import React, { Component } from 'react';
import { AuthContext } from '../context/AuthContext';

class UserMenu extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.menuRef.current && !this.menuRef.current.contains(event.target)) {
      this.closeMenu();
    }
  };

  toggleMenu = () => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  };

  closeMenu = () => {
    this.setState({ isOpen: false });
  };

  handleNavigation = (path) => {
    this.closeMenu();
    this.props.onNavigate(path);
  };

  handleLogout = () => {
    this.closeMenu();
    this.context.logout();
    this.props.onNavigate('/login');
  };

  componentDidUpdate(prevProps) {
    // Close menu when prop changes (e.g., notifications opened)
    if (this.props.isOpen !== undefined && this.props.isOpen !== prevProps.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  render() {
    const { user } = this.context;
    const { isAdmin = false } = this.props;
    const { isOpen } = this.state;

    if (!user) return null;

    return (
      <div className="relative" ref={this.menuRef}>
        <button
          onClick={this.toggleMenu}
          className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-slate-50 transition"
        >
          {/* <div className="text-right hidden sm:block">
            <p className="text-sm font-medium text-slate-900">{user.name}</p>
            <p className="text-xs text-slate-500">{user.email}</p>
          </div> */}
          <div className="w-9 h-9 bg-slate-800 rounded-full flex items-center justify-center">
            <span className="text-sm font-semibold text-white">
              {user.firstName.charAt(0).toUpperCase()}{user.lastName.charAt(0).toUpperCase()}
            </span>
          </div>
          <svg
            className={`w-4 h-4 text-slate-600 transition-transform ${
              isOpen ? 'rotate-180' : ''
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
            {/* User Info Header */}
            <div className="px-4 py-3 border-b border-slate-200">
              <p className="text-sm font-medium text-slate-900">{user.firstName} {user.lastName}</p>
              <p className="text-xs text-slate-500 truncate">{user.email}</p>
            </div>
            
            {/* Menu Items */}
            <button 
              onClick={() => this.handleNavigation('/account')}
              className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition flex items-center space-x-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span>My Account</span>
            </button>

            {isAdmin && (
              <button 
                onClick={() => this.handleNavigation('/manage-users')}
                className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition flex items-center space-x-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                <span>Manage Users</span>
              </button>
            )}

            <button
              onClick={() => {
                this.props.onNavigate('/subscriptions'); 
                this.setState({ showMenu: false });
              }}
              className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 flex items-center space-x-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <span>Job Subscriptions</span>
            </button>
            
            {/* Logout */}
            <div className="border-t border-slate-200 mt-1 pt-1">
              <button 
                onClick={this.handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition flex items-center space-x-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                <span>Logout</span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UserMenu;